// extracted by mini-css-extract-plugin
export default {"tabBarWrapper":"Homepage_tabBarWrapper__sonfq"};